import { render } from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=template&id=6c4c5977&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOnlinePublications.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOnlinePublications.vue?vue&type=style&index=0&id=6c4c5977&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4c5977"]])

export default __exports__